import styled from 'styled-components';

export const DefaultLogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const DefaultLogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;
